import React from 'react';
import xosphereLogo from '../../assets/images/xosphere-footer-logo.png';
import './Footer.css';

const footer = (props) => {
    return (
        <footer className="footer">
            <div className="container">
                <div className="row">
                    <div className="col-lg-7">
                        <div className="row">
                            <div className="col-lg-5"><img src={xosphereLogo} alt="" title=""
                                                           className="footer-logo"/></div>
                            <div  className="col-lg-3"></div>
                            <div className="col-lg-4 contact-details"> 800-905-4125  <a href="mailto:hello@xosphere.io"
                                                                                       className="email">hello@xosphere.io</a>
                            </div>

                        </div>
                    </div>
                    <div className="col-lg-5 text-right">
                        <div className="social-links"><a href="https://www.facebook.com/XosphereInc/" className="facebook"><i
                            className="fa fa-facebook"></i></a> <a href="https://www.linkedin.com/company/xosphereinc/" className="linkedin"><i
                            className="fa fa-linkedin"></i></a> <a href="https://twitter.com/XosphereInc" className="twitter"><i
                            className="fa fa-twitter"></i></a></div>
                        <div className="copyright">&copy; Copyright 2018 Xosphere, Inc. All rights reserved.</div>
                    </div>
                </div>
            </div>
        </footer>

    )
};

export default footer;